export default {
  partnerid: '7287dp02O2T3',
  API: 'http://www.wcareer.cn/clubapi', //嘉年华api
  // API:"http://192.168.0.111:9090/uguo/clubapi",
  LOGIN: 'http://www.wcareer.cn/club', //用户登录
  UGUO_API: 'http://www.wcareer.cn/api' //优果api
}



// WEBPACK FOOTER //
// ./src/config/config.api.js